import { useMemo } from "react";
import { NavLink, useParams } from "react-router-dom";
import { LayoutDashboard, CalendarDays, FileText, Users, BookOpen } from "lucide-react";
import { useClasseContext } from "../../context/ClasseContext";
import { useUser } from "../../context/UserContext";
import { getAccessType } from "../../utils/permissions";

// Bandeau d'onglets des pages de pilotage d'une classe ou d'un groupe.
// Aucune prop : tout est lu depuis l'URL et les contexts, pour une insertion
// en une ligne au niveau des loaders (DataLoader, EvalNatLoader, GroupeBesoins).
function PilotageTabs() {
    const { idclasse } = useParams();
    const { classeNom, groupNom, classeDetail, classesGroup } = useClasseContext();
    const { user, etablissementData } = useUser();

    const accessType = useMemo(() => {
        if (!idclasse || !user || !etablissementData) return 'none';
        return getAccessType(parseInt(idclasse, 10), user, etablissementData);
    }, [idclasse, user, etablissementData]);

    // Garde de rôle : le chef a accessType 'full' partout (bypass permissions.js),
    // mais Progression et Groupes restent hors de son périmètre.
    const isProf = user?.role === 'professeur';
    const hasEleves = !!(classeDetail?.eleves && classeDetail.eleves.length !== 0);
    const isNiveauEvalNat =
        (classeNom && (classeNom[0] === "6" || classeNom[0] === "5" || classeNom[0] === "4")) ||
        (classesGroup && classesGroup.length !== 0 && classesGroup[0] && (classesGroup[0][0] === "6" || classesGroup[0][0] === "5"));

    const onglets = [
        { label: "Tableau de bord", to: `/home/detail/${idclasse}`, icone: LayoutDashboard, visible: true },
        { label: "Programmation", to: `/home/progression/${idclasse}`, icone: CalendarDays, visible: isProf && accessType === 'full' && hasEleves },
        { label: "Résultats nationaux", to: `/home/eval-nat/${idclasse}`, icone: FileText, visible: !!isNiveauEvalNat && hasEleves },
        { label: "Groupes", to: `/home/groupes/${idclasse}`, icone: Users, visible: isProf && !groupNom && accessType === 'full' && hasEleves },
        { label: "Savoirs", to: `/home/savoirs/${idclasse}`, icone: BookOpen, visible: accessType === 'full' && hasEleves },
    ];

    return (
        <div className="px-4 pt-4">
            <div className="inline-flex flex-wrap gap-1 bg-white rounded-xl border border-slate-200 shadow-sm p-1">
                {onglets.filter(o => o.visible).map(({ label, to, icone: Icone }) => (
                    <NavLink
                        key={to}
                        to={to}
                        className={({ isActive }) =>
                            `flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-[13px] font-medium transition-colors duration-200 ${
                                isActive
                                    ? 'bg-gradient-to-br from-blue-500 to-cyan-500 text-white shadow-md shadow-blue-500/30'
                                    : 'text-slate-600 hover:text-slate-900 hover:bg-slate-50'
                            }`
                        }
                    >
                        <Icone className="w-4 h-4" />
                        {label}
                    </NavLink>
                ))}
            </div>
        </div>
    );
}

export default PilotageTabs;
